import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './components/Dashboard'
import Mailings from './components/Mailings'
import Settings from './components/Settings'
import SearchView from './components/SearchView'
import ContactList from './components/ContactList'
import ContactForm from './components/ContactForm'
import ContactMerge from './components/ContactMerge'
import ContactMassEdit from './components/ContactMassEdit'
import GroupView from './components/GroupView'
import MailingView from './components/MailingView'
import CampaignView from './components/CampaignView'

Vue.use(Router)

const router = new Router({
  routes: [
    // { path: '/:flag?', name: 'mailings', component: Mailings, props: true, meta: { title: 'FM-CRM - Mailings' } },
    { path: '/dashboard/:flag?', name: 'dashboard', component: Dashboard, props: true, meta: { title: 'FM-CRM - Dashboard' } },
    { path: '/mailings/:flag?', name: 'mailings', component: Mailings, props: true, meta: { title: 'FM-CRM - Mailings' } },
    // { path: '/settings', name: 'settings', component: Settings, meta: { title: 'FM-CRM - Settings' } },

    { path: '/:flag?', name: 'home', component: Dashboard, props: true, meta: { title: 'FM-CRM - Dashboard' } },

    { path: '/search/:id?/:title?', name: 'search', component: SearchView, props: true, meta: { title: 'FM-CRM - Edit Search' } },
    { path: '/contact/edit/:contact_id/:title?', name: 'contact.edit', component: ContactForm, props: true, meta: { title: 'FM-CRM - Edit Contact' } },
    { path: '/contact/extended_search/:search_id?/:title?', name: 'contact.extended_search', component: ContactList, props: true, meta: { title: 'FM-CRM - Search Contacts' } },
    { path: '/contact/search_all/:title?', name: 'contact.search_all', component: ContactList, props: true, meta: { title: 'FM-CRM - Search Contacts' } },
    { path: '/contact/simple_search/:simple_search', name: 'contact.simple_search', component: ContactList, props: true, meta: { title: 'FM-CRM - Search Contacts' } },
    { path: '/contact/group/:search_id?/:title?', name: 'contact.group', component: ContactList, props: true, meta: { title: 'FM-CRM - Search Contacts' } },
    { path: '/contact/merge/:ids/:search_id?', name: 'contact.merge', component: ContactMerge, props: true, meta: { title: 'FM-CRM - Merge Contacts' } },
    { path: '/contact/mass_edit/:ids/:search_id?', name: 'contact.mass_edit', component: ContactMassEdit, props: true, meta: { title: 'FM-CRM - Mass Edit Contacts' } },
    { path: '/contact/settings', name: 'contact.settings', component: Settings, meta: { title: 'FM-CRM - Settings' } },
    { path: '/group/:group_id?/:title?', name: 'group', component: GroupView, props: true, meta: { title: 'FM-CRM - Edit Group' } },
    { path: '/mailing/:id?/:title?', name: 'mailing', component: MailingView, props: true, meta: { title: 'FM-CRM - Edit Mailing' } },
    { path: '/campaign/:id?/:title?', name: 'campaign', component: CampaignView, props: true, meta: { title: 'FM-CRM - Edit Campaign' } },
    { path: '/campaign/mailing/:id?/:title?', name: 'campaign.mailing', component: MailingView, props: true, meta: { title: 'FM-CRM - Campaign Mailings' } },
  ]
})

// eslint-disable-next-line
router.afterEach((to, from) => {
  setTimeout(() => {
    document.title = to.meta.title || 'FM-CRM'
  }, 100)
})

export default router
